import { COUNTRIES, EU_FREE_MOVEMENT_CODES } from '../../constants/countries';

export const LANGUAGE_TO_COUNTRY: Record<string, string> = {
    EN: 'GB', DE: 'DE', NL: 'NL', PL: 'PL', RU: 'RU', HU: 'HU',
    FR: 'FR', RO: 'RO', ES: 'ES', IT: 'IT', CS: 'CZ', BG: 'BG',
    HR: 'HR', TR: 'TR', PT: 'PT', LT: 'LT', LV: 'LV', EE: 'EE',
    SK: 'SK', SL: 'SI',
};

export const NATIONALITY_OPTIONS = COUNTRIES.filter((country) => EU_FREE_MOVEMENT_CODES.includes(country.code));
export const NATIONALITY_LABELS: Record<string, string> = Object.fromEntries(
    NATIONALITY_OPTIONS.map((country) => [country.code, country.name]),
);
